import DataMap from 'assets/components/dataMap/DataMap';
import ErrorWrapper from 'assets/components/inputs/wrappers/ErrorWrapper';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import { Fragment } from 'react';
import { useSalesContractProvider } from '../../Sales.Contract.Hooks';

const ContractInfoStatusAuditLogs = () => {
  const { lang } = getLocales();
  const { contractStatusAuditLogListApi } = useSalesContractProvider();

  return (
    <>
      {!contractStatusAuditLogListApi.payload?.data?.length ? (
        <ErrorWrapper children={lang.noInfo} />
      ) : (
        <table className={ThemeTableSimple}>
          <DataMap
            data={contractStatusAuditLogListApi?.payload?.data}
            render={({ data: log }) => (
              <Fragment key={log.id}>
                <thead>
                  <tr>
                    <th>Old status</th>
                    <th>New Status</th>
                    <th>Changed on</th>
                    <th>Changed by</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{log.oldStatus}</td>
                    <td>{log.newStatus}</td>
                    <td>{log.createdAtUtc}</td>
                    <td>{log.createdBy?.displayInfo?.title}</td>
                  </tr>
                </tbody>
              </Fragment>
            )}
          />
        </table>
      )}
    </>
  );
};

export default ContractInfoStatusAuditLogs;
